// =============================================================================
// INSTRUCCIONES DE INTEGRACIÓN EN Creditos.jsx
// =============================================================================
// 1. Agrega 'recordatorios' al array de tabs:
//    { key: 'recordatorios', label: '🔔 Recordatorios' }
//
// 2. Agrega los estados al componente principal:
//    const [recConfig,    setRecConfig]    = useState(null);
//    const [recWhitelist, setRecWhitelist] = useState(null);
//    const [recHistorial, setRecHistorial] = useState(null);
//    const [recPreview,   setRecPreview]   = useState(null);
//    const [recCargando,  setRecCargando]  = useState(false);
//    const [modalConfig,  setModalConfig]  = useState(false);
//    const [modalWL,      setModalWL]      = useState(false);
//
// 3. Agrega el useEffect:
//    useEffect(() => {
//      if (tab === 'recordatorios') cargarRecordatorios();
//    }, [tab]);
//
// 4. Agrega las funciones (ver abajo) y el bloque JSX del tab.
// =============================================================================

// ── Funciones a agregar dentro del componente Creditos ──────────────────────

/*
  const cargarRecordatorios = async () => {
    setRecCargando(true);
    try {
      const [cfg, wl, hist, prev] = await Promise.all([
        api.get('/recordatorios/config'),
        api.get('/recordatorios/whitelist'),
        api.get('/recordatorios/historial'),
        api.get('/recordatorios/preview'),
      ]);
      setRecConfig(cfg.error   ? null : cfg);
      setRecWhitelist(wl.error ? [] : wl.whitelist);
      setRecHistorial(hist.error ? [] : hist.historial);
      setRecPreview(prev.error ? null : prev);
    } catch(e) { console.error(e); }
    finally { setRecCargando(false); }
  };

  const toggleActivo = async () => {
    await api.patch('/recordatorios/config/toggle', {});
    cargarRecordatorios();
  };

  const ejecutarAhora = async () => {
    if (!window.confirm('¿Enviar recordatorios ahora?')) return;
    setRecCargando(true);
    try {
      const res = await api.post('/recordatorios/ejecutar', {});
      alert(res.error ? `Error: ${res.error}` : `✅ ${res.enviados} enviado(s) · ${res.errores} error(es)`);
      cargarRecordatorios();
    } catch(e) { alert('Error de conexión'); }
    finally { setRecCargando(false); }
  };

  const eliminarWhitelist = async (id) => {
    await api.delete(`/recordatorios/whitelist/${id}`);
    cargarRecordatorios();
  };
*/

// ── JSX del tab — pegar dentro del return, junto al resto de tabs ────────────

import { useState } from 'react';

export function TabRecordatorios({
  recCargando, recConfig, recWhitelist, recHistorial, recPreview,
  toggleActivo, ejecutarAhora, eliminarWhitelist,
  modalConfig, setModalConfig, modalWL, setModalWL,
  cargarRecordatorios,
}) {
  // ── Form configuración ──
  const [cfgForm, setCfgForm] = useState({
    numero_destino:   '',
    numero_destino_2: '',   // ← agregar esto
    numero_origen:    'whatsapp:+593968720829',
    twilio_sid:       '',
    twilio_token:     '',
    template_sid_30:  '',
    template_sid_60:  '',
    activo:           true,
});

  // ── Form whitelist ──
  const [wlForm, setWlForm] = useState({ ruc: '', nombre: '', motivo: '' });
  const [guardandoCfg, setGuardandoCfg] = useState(false);
  const [guardandoWL,  setGuardandoWL]  = useState(false);
  const [errCfg, setErrCfg] = useState('');
  const [errWL,  setErrWL]  = useState('');

  const guardarConfig = async () => {
    setGuardandoCfg(true); setErrCfg('');
    try {
      const res = await (await import('../api')).api.post('/recordatorios/config', cfgForm);
      if (res.error) { setErrCfg(res.error); return; }
      setModalConfig(false);
      cargarRecordatorios();
    } catch(e) { setErrCfg('Error de conexión'); }
    finally { setGuardandoCfg(false); }
  };

  const guardarWL = async () => {
    if (!wlForm.ruc.trim() || !wlForm.nombre.trim()) { setErrWL('RUC y nombre requeridos'); return; }
    setGuardandoWL(true); setErrWL('');
    try {
      const res = await (await import('../api')).api.post('/recordatorios/whitelist', wlForm);
      if (res.error) { setErrWL(res.error); return; }
      setWlForm({ ruc: '', nombre: '', motivo: '' });
      setModalWL(false);
      cargarRecordatorios();
    } catch(e) { setErrWL('Error de conexión'); }
    finally { setGuardandoWL(false); }
  };

  const fmtSaldo = (n) => (n || 0).toLocaleString('es-EC', { minimumFractionDigits: 2 });

  return (
    <div>
      {/* ── Header ── */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h3 style={{ color: '#fff', margin: 0 }}>🔔 Recordatorios de cobro</h3>
          <p style={{ color: '#555', fontSize: 12, marginTop: 4 }}>
            Avisos automáticos a los 30 y 60 días por WhatsApp
          </p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={sr.btnSecundario} onClick={() => setModalConfig(true)}>⚙️ Configurar</button>
          <button style={sr.btnSecundario} onClick={() => setModalWL(true)}>+ Whitelist</button>
          {recConfig?.configurado && (
            <>
              <button
                onClick={toggleActivo}
                style={{
                  ...sr.btnSecundario,
                  borderColor: recConfig.activo ? '#4caf50' : '#555',
                  color:       recConfig.activo ? '#4caf50' : '#555',
                }}>
                {recConfig.activo ? '✅ Activo' : '⏸ Pausado'}
              </button>
              <button style={sr.btnPrimario} onClick={ejecutarAhora} disabled={recCargando}>
                {recCargando ? '...' : '▶ Ejecutar ahora'}
              </button>
            </>
          )}
        </div>
      </div>

      {recCargando && <p style={{ color: '#aaa', textAlign: 'center', padding: 40 }}>Cargando...</p>}

      {!recCargando && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>

          {/* ── Columna izquierda ── */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

            {/* Estado configuración */}
            <div style={sr.card}>
              <div style={sr.cardTitulo}>⚙️ Configuración</div>
              {!recConfig?.configurado ? (
                <div style={{ color: '#555', fontSize: 13 }}>
                  Sin configurar. Presiona "Configurar" para ingresar los datos de Twilio y los SID de los templates.
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {[
                    ['Número destino', recConfig.numero_destino],
                    ['Número destino 2', recConfig.numero_destino_2 || '—'],
                    ['Número origen',  recConfig.numero_origen],
                    ['Template 30d',   recConfig.tiene_sid_30 ? '✅ Configurado' : '❌ Falta'],
                    ['Template 60d',   recConfig.tiene_sid_60 ? '✅ Configurado' : '❌ Falta'],
                  ].map(([label, val]) => (
                    <div key={label} style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ color: '#555', fontSize: 12 }}>{label}</span>
                      <span style={{ color: '#aaa', fontSize: 12 }}>{val}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Preview de hoy */}
            <div style={sr.card}>
              <div style={sr.cardTitulo}>👁 Preview — envíos de hoy</div>
              {!recPreview ? (
                <p style={{ color: '#555', fontSize: 13 }}>Sin datos</p>
              ) : recPreview.total === 0 ? (
                <p style={{ color: '#4caf50', fontSize: 13 }}>✅ Sin recordatorios pendientes hoy</p>
              ) : (
                <>
                  <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
                    <div style={sr.badge30}>{recPreview.pendientes_30?.length || 0} a 30d</div>
                    <div style={sr.badge60}>{recPreview.pendientes_60?.length || 0} a 60d</div>
                  </div>
                  {[...(recPreview.pendientes_30 || []), ...(recPreview.pendientes_60 || [])].map((f, i) => (
                    <div key={i} style={{
                      display: 'flex', justifyContent: 'space-between',
                      padding: '6px 0', borderBottom: '1px solid #1a1a2e', fontSize: 12,
                    }}>
                      <span style={{ color: '#fff' }}>{f.cliente}</span>
                      <div style={{ textAlign: 'right' }}>
                        <span style={{ color: f.dias === 30 ? '#ffc107' : '#e63946', fontWeight: 'bold' }}>
                          {f.dias}d
                        </span>
                        <span style={{ color: '#4cc9f0', marginLeft: 8 }}>${fmtSaldo(f.saldo)}</span>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>

            {/* Whitelist */}
            <div style={sr.card}>
              <div style={sr.cardTitulo}>🛡 Whitelist — clientes exentos ({recWhitelist?.length || 0})</div>
              {(!recWhitelist || recWhitelist.length === 0) ? (
                <p style={{ color: '#555', fontSize: 13 }}>Sin clientes exentos</p>
              ) : recWhitelist.map((w) => (
                <div key={w.id} style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '8px 0', borderBottom: '1px solid #1a1a2e',
                }}>
                  <div>
                    <div style={{ color: '#fff', fontSize: 13 }}>{w.nombre}</div>
                    <div style={{ color: '#555', fontSize: 11 }}>{w.ruc}{w.motivo ? ` · ${w.motivo}` : ''}</div>
                  </div>
                  <button
                    onClick={() => eliminarWhitelist(w.id)}
                    style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer', fontSize: 16 }}>
                    ✕
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* ── Columna derecha: historial ── */}
          <div style={sr.card}>
            <div style={sr.cardTitulo}>📋 Historial de envíos (últimos 100)</div>
            {(!recHistorial || recHistorial.length === 0) ? (
              <p style={{ color: '#555', fontSize: 13 }}>Sin envíos registrados</p>
            ) : (
              <div style={{ maxHeight: 520, overflowY: 'auto' }}>
                {recHistorial.map((h) => (
                  <div key={h.id} style={{
                    padding: '10px 0',
                    borderBottom: '1px solid #1a1a2e',
                    borderLeft: `3px solid ${h.estado === 'enviado' ? '#4caf50' : '#e63946'}`,
                    paddingLeft: 10,
                    marginBottom: 4,
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3 }}>
                      <span style={{ color: '#fff', fontSize: 13, fontWeight: '600' }}>{h.cliente}</span>
                      <span style={{
                        background: h.dias === 30 ? '#3a2e10' : '#3a1a1a',
                        color:      h.dias === 30 ? '#ffc107' : '#e63946',
                        borderRadius: 6, padding: '1px 8px', fontSize: 10, fontWeight: 'bold',
                      }}>
                        {h.dias}d
                      </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ color: '#555', fontSize: 11 }}>{h.factura}</span>
                      <span style={{ color: '#4cc9f0', fontSize: 11 }}>${fmtSaldo(h.saldo)}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
                      <span style={{ color: h.estado === 'enviado' ? '#4caf50' : '#e63946', fontSize: 10 }}>
                        {h.estado === 'enviado' ? '✅ Enviado' : `❌ ${h.error_msg}`}
                      </span>
                      <span style={{ color: '#333', fontSize: 10 }}>{h.enviado_at}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* ══ MODAL CONFIGURACIÓN ══ */}
      {modalConfig && (
        <>
          <div onClick={() => setModalConfig(false)}
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 200 }} />
          <div style={sr.modal}>
            <div style={sr.modalHeader}>
              <span style={{ color: '#fff', fontWeight: 'bold' }}>⚙️ Configurar recordatorios</span>
              <button onClick={() => setModalConfig(false)} style={sr.btnCerrar}>✕</button>
            </div>
            <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 14 }}>
              {[
                ['numero_destino',  'Número WhatsApp destino',  '+593XXXXXXXXX — encargada de créditos'],
                ['numero_destino_2', 'Número WhatsApp destino 2 (opcional)', '+593XXXXXXXXX'],
                ['numero_origen',   'Número WhatsApp origen',   'whatsapp:+593968720829 (Twilio)'],
                ['twilio_sid',      'Twilio Account SID',       'ACxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'],
                ['twilio_token',    'Twilio Auth Token',        'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'],
                ['template_sid_30', 'Content SID template 30d', 'HXxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'],
                ['template_sid_60', 'Content SID template 60d', 'HXxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'],
              ].map(([key, label, placeholder]) => (
                <div key={key}>
                  <div style={{ color: '#888', fontSize: 11, fontWeight: 'bold', marginBottom: 4 }}>{label}</div>
                  <input
                    style={sr.inputModal}
                    value={cfgForm[key]}
                    onChange={e => setCfgForm(p => ({ ...p, [key]: e.target.value }))}
                    placeholder={placeholder}
                    type={key.includes('token') ? 'password' : 'text'}
                  />
                </div>
              ))}
              {errCfg && <p style={{ color: '#e63946', fontSize: 13 }}>{errCfg}</p>}
              <button
                style={{ ...sr.btnPrimario, opacity: guardandoCfg ? 0.6 : 1 }}
                onClick={guardarConfig}
                disabled={guardandoCfg}>
                {guardandoCfg ? 'Guardando...' : '💾 Guardar configuración'}
              </button>
            </div>
          </div>
        </>
      )}

      {/* ══ MODAL WHITELIST ══ */}
      {modalWL && (
        <>
          <div onClick={() => setModalWL(false)}
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 200 }} />
          <div style={{ ...sr.modal, maxWidth: 400 }}>
            <div style={sr.modalHeader}>
              <span style={{ color: '#fff', fontWeight: 'bold' }}>🛡 Agregar a whitelist</span>
              <button onClick={() => setModalWL(false)} style={sr.btnCerrar}>✕</button>
            </div>
            <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 14 }}>
              {[
                ['ruc',    'RUC del cliente',   '0990000000001'],
                ['nombre', 'Nombre',            'EMPRESA S.A.'],
                ['motivo', 'Motivo (opcional)', 'Plazo libre por acuerdo comercial'],
              ].map(([key, label, placeholder]) => (
                <div key={key}>
                  <div style={{ color: '#888', fontSize: 11, fontWeight: 'bold', marginBottom: 4 }}>{label}</div>
                  <input
                    style={sr.inputModal}
                    value={wlForm[key]}
                    onChange={e => setWlForm(p => ({ ...p, [key]: e.target.value }))}
                    placeholder={placeholder}
                  />
                </div>
              ))}
              {errWL && <p style={{ color: '#e63946', fontSize: 13 }}>{errWL}</p>}
              <button
                style={{ ...sr.btnPrimario, opacity: guardandoWL ? 0.6 : 1 }}
                onClick={guardarWL}
                disabled={guardandoWL}>
                {guardandoWL ? 'Guardando...' : '+ Agregar a whitelist'}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

// ── Estilos del tab ──────────────────────────────────────────────────────────
export const sr = {
  card:          { background: '#1e1e2e', borderRadius: 12, padding: 20 },
  cardTitulo:    { color: '#fff', fontWeight: 'bold', fontSize: 14, marginBottom: 14 },
  badge30:       { background: '#3a2e10', color: '#ffc107', borderRadius: 8, padding: '4px 12px', fontSize: 12, fontWeight: 'bold' },
  badge60:       { background: '#3a1a1a', color: '#e63946', borderRadius: 8, padding: '4px 12px', fontSize: 12, fontWeight: 'bold' },
  btnPrimario:   { background: '#1a2a3e', border: '1px solid #4cc9f0', borderRadius: 8, color: '#4cc9f0', padding: '8px 18px', cursor: 'pointer', fontWeight: 'bold', fontSize: 13 },
  btnSecundario: { background: 'none', border: '1px solid #2d2d44', borderRadius: 8, color: '#aaa', padding: '8px 16px', cursor: 'pointer', fontSize: 13 },
  modal:         { position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', background: '#1a1a2e', borderRadius: 16, border: '1px solid #2d2d44', width: '90%', maxWidth: 560, zIndex: 201, maxHeight: '90vh', overflowY: 'auto' },
  modalHeader:   { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 24px', borderBottom: '1px solid #2d2d44' },
  btnCerrar:     { background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', fontSize: 16, cursor: 'pointer', padding: '4px 10px' },
  inputModal:    { width: '100%', background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, color: '#fff', padding: '10px 12px', fontSize: 13, boxSizing: 'border-box' },
};
